import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { FaArrowRight, FaCompass, FaExternalLinkAlt, FaTimes } from 'react-icons/fa';
import { abrirPrimeirosPassos } from '../../components/onboarding-checklist/OnboardingChecklist';
import styled from 'styled-components';
import { onboardingService } from '../../services/onboarding';
import { rastrearTeste } from '../../services/rastreamentoTeste';
import { tokens } from '../../components/modal-form/tokens';
import { Dor, doresPorChave } from './dores';
import { CartaoCaminho, GradeDores } from './styles';

export const PARAMETRO_PRIORIDADES = 'prioridades';

const Cabecalho = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    padding: 22px 24px 6px;
    font-family: ${tokens.fontFamily};

    h2 { margin: 0 0 4px; font-size: 1.25rem; font-weight: 600; color: ${tokens.textPrimary}; }
    p { margin: 0; font-size: ${tokens.fontBase}; color: ${tokens.textMuted}; line-height: 1.5; }
    button { border: none; background: none; color: ${tokens.textHint}; cursor: pointer; padding: 4px; font-size: 18px; }
`;

const Corpo = styled.div`
    padding: 16px 24px 24px;
    font-family: ${tokens.fontFamily};
`;

// Depois do onboarding, o painel abre com as prioridades que o locador escolheu no começo. Cada
// uma abre a tela dela em outra guia, para ele não perder o painel.
export default function ModalPrioridades() {
    const location = useLocation();
    const history = useHistory();
    const pedido = new URLSearchParams(location.search).get(PARAMETRO_PRIORIDADES) === 'true';
    const [dores, setDores] = useState<Dor[]>([]);

    useEffect(() => {
        if (!pedido) return;
        // Sem prioridades para mostrar, sai do pedido: o dashboard então abre o "Primeiros Passos".
        onboardingService.status()
            .then(s => {
                const escolhidas = doresPorChave(s.dores);
                if (escolhidas.length) setDores(escolhidas);
                else fechar();
            })
            .catch(() => fechar());
    }, [pedido]);

    const fechar = () => {
        const params = new URLSearchParams(location.search);
        params.delete(PARAMETRO_PRIORIDADES);
        history.replace({ pathname: location.pathname, search: params.toString() });
        setDores([]);
    };

    return (
        <Modal show={pedido && dores.length > 0} onHide={fechar} centered size="lg">
            <Cabecalho>
                <div>
                    <h2>Por onde começar</h2>
                    <p>Estas são as prioridades que você escolheu. Cada uma abre em outra guia, e o painel continua aqui.</p>
                </div>
                <button type="button" aria-label="Fechar" onClick={fechar}><FaTimes /></button>
            </Cabecalho>
            <Corpo>
                <GradeDores>
                    {dores.map(dor => {
                        const Icone = dor.icone;
                        return (
                            <CartaoCaminho key={dor.chave} href={dor.rota} target="_blank" rel="noopener noreferrer"
                                onClick={() => rastrearTeste('prioridades_cartao_clicado', { dor: dor.chave })}>
                                <span className="titulo"><Icone /> {dor.titulo}</span>
                                <span className="texto">{dor.comoResolvemos}</span>
                                <span className="acao">Abrir {dor.tela} <FaExternalLinkAlt /></span>
                            </CartaoCaminho>
                        );
                    })}
                    {/* Além das prioridades: ficar no painel e abrir o "Primeiros Passos". */}
                    <CartaoCaminho as="button" type="button" onClick={() => { rastrearTeste('explorar_sistema_clicado'); fechar(); abrirPrimeirosPassos('explorar'); }}>
                        <span className="titulo"><FaCompass /> Explorar o Sistema</span>
                        <span className="texto">Fique no painel e siga os primeiros passos para conhecer o LocaSmartPro.</span>
                        <span className="acao">Ver os primeiros passos <FaArrowRight /></span>
                    </CartaoCaminho>
                </GradeDores>
            </Corpo>
        </Modal>
    );
}
